<template>
  <div
    class="story-text-background"
    style="background-image: url('@/../static/images/backgrounds/operation-crossroads.jpg');"
    v-rjs="2"
    v-touch:swipeleft="swipeLeft"
  >
    <div class="story-text desktop" :class="{ hideMobileDrawerOpen: drawerOpen }">
      <span class="typewriter-char" :class="{ display: idx <= 90 }" v-for="char, idx in msg" :id="`${idx}-char`">{{ char }}</span>
    </div>
    <div class="story-text mobile" :class="{ hideMobileDrawerOpen: mobileOpen }">
      <span class="typewriter-char" :class="{ display: idx <= 90 }" v-for="char, idx in mobileMsg" :id="`${idx}-charMobile`">{{ char }}</span>
    </div>
    <div class="swipe-graphic" id="swipe-graphic" :class="{ active: doneTypingMobile, hideMobileDrawerOpen: mobileOpen }">
      <img src="@/../static/images/graphics/swipe-left.svg" alt="Swipe Left">
    </div>    
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';

  export default {
    name: 'story-text',
    data() {
      return {
        msg: 'In 1946, the US Navy conducted ‘Operation Crossroads’; a series of \nnuclear tests at Bikini Atoll in the sparsely populated \nMarshall Islands. \n\nExploding two bombs, ABLE and BAKER, the aim was to prove that \na modern fleet could withstand atomic attack.\n\n Today, the wrecks still litter the seabed around the island of Bikini;\n a testament to the power of nuclear weapons. \n\nUse the interactive map on the right to explore the aftermath of this unique graveyard of Second World War warships.',
        mobileMsg: 'In 1946, the US Navy conducted ‘Operation Crossroads’; a series of \nnuclear tests at Bikini Atoll in the sparsely populated \nMarshall Islands. \n\nExploding two bombs, ABLE and BAKER, the aim was to prove that \na modern fleet could withstand atomic attack.\n\n Today, the wrecks still litter the seabed around the island of Bikini; a testament \nto the power of nuclear weapons.\n\nSwipe left to use our interactive map to explore the aftermath of a nuclear detonation.',
        currentChar: 90,
        currentCharMobile: 90,
        doneTyping: false,
        doneTypingMobile: false,
        raf: undefined,
      };
    },
    computed: {
      ...mapGetters('ui', [
        'shouldTypeStoryText',
        'drawerOpen',
        'mobileOpen',
      ]),
    },
    methods: {
      ...mapMutations('ui', [
        'setDrawerState',
        'setMobileState',
      ]),
      typeOut() {
        if (this.currentChar >= this.msg.length) {
          this.doneTyping = true;
          return;
        }

        document.getElementById(`${this.currentChar}-char`).classList.add('display');
        this.currentChar += 1;

        this.timeout = setTimeout(() => {
          this.raf = requestAnimationFrame(this.typeOut);
        }, (Math.random() * 35) + 15);
      },
      typeOutMobile() {
        if (this.currentCharMobile >= this.mobileMsg.length) {
          this.doneTypingMobile = true;
          return;
        }

        document.getElementById(`${this.currentCharMobile}-charMobile`).classList.add('display');
        this.currentCharMobile += 1;

        this.timeout = setTimeout(() => {
          this.raf = requestAnimationFrame(this.typeOutMobile);
        }, (Math.random() * 35) + 15);
      },
      swipeLeft() {
        if (this.doneTypingMobile) {
          this.setMobileState({ open: true });
        }
      },
    },
    beforeDestroy() {
      clearTimeout(this.timeout);
    },
    watch: {
      shouldTypeStoryText() {
        setTimeout(() => {
          this.typeOut();
          this.typeOutMobile();
        }, 1300);
      },
    },
  };
</script>

<style scoped lang='scss'>
  .hideMobileDrawerOpen {
    opacity: 0 !important;
    transition: opacity 300ms;
  }

  .swipe-graphic,
  .story-text {
    transition: opacity 300ms;
  }

  .story-text-background {
    background-size: cover;
    background-position: 20% center;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .story-text {
    width: 100%;
    font-family: "Special Elite", cursive;
    white-space: pre-line;
    text-align: center;
    font-size: 13px;
    padding: 18.13% 4.84% 0;
    box-sizing: border-box;
    pointer-events: none;
    line-height: 16px;
    text-shadow: 0 0 10px rgba(215, 219, 223, 0.8);
  }

  .typewriter-char {
    opacity: 0;

    &.display {
      opacity: 1;
    }
  }

  .swipe-graphic {
    width: 52px;
    margin: 30px auto;
    opacity: 0;
    transition: .3s opacity;

    img {
      width: 100%;
      height: auto;
    }

    &.active {
      opacity: 1;
    }
  }

  .story-text.desktop {
    display: none;
  }

  .social {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translate(-50%);
    transition: 300ms opacity;

    &.hideSocial {
      opacity: 0;
    }

    .social-element {
      display: inline-block;
      height: 25px;
      margin: 0 5px;
      img {
        width: auto;
        height: 100%;
      }
    }
  }

  @media screen and (min-width: 375px) {
    .story-text {
      font-size: 16px;
      line-height: normal;
      padding-top: 14.13%;
    }
  }

  @media screen and (min-width: 400px) {
    .story-text {
      font-size: 18px;
      line-height: 22px;
    }
  }

  @media screen and (min-width: 768px) {
    .story-text-background {
      background-position: 15% center;
    }
  }

  @media screen and (min-width: 992px) {
    .story-text-background {
      background-position: 29% center;
    }
    .story-text {
      padding: 4.13% 4.84% 0;
      font-size: 17px;
      line-height: 26px;
    }

    .story-text.desktop {
      width: 60%;
      display: block;
    }

    .story-text.mobile {
      display: none;
    }

    .swipe-graphic {
      &.active {
        opacity: 0;
      }
    }
    .social {
      padding-right: 10px;
      left: 60%;
      transform: translate(-100%);
      &.hideSocial {
        opacity: 1;
      }
      &.hideSocialDesktop {
        opacity: 0;
      }
    }

    .story-text {
      font-size: 15px;
      line-height: 18px;
      padding: 7.13% 2.84% 0;
    }
  }

  @media screen and (min-width: 1200px) {
    .story-text {
      font-size: 18px;
      line-height: 20px;
    }
  }

  @media screen and (min-width: 1500px) {
    .story-text {
      font-size: 20px;
      line-height: 30px;
      padding: 7.13% 4.84% 0;
    }
  }

  @media screen and (min-width: 2000px) {
    .story-text {
      font-size: 24px;
      line-height: 34px;
      padding: 5.13% 4.84% 0;
    }
  }
</style>


// WEBPACK FOOTER //
// StoryText.vue?beb80068